import { cdnClient } from '@vista/omnichannel-components-domain';
import { FilmImageMediaType } from '../components/film/image/types/media-type';
import { FilmHeroBannerMediaType } from '../components/film-hero-banner/types/media-type';
export const getFilmCdnUrlForMedia = (film, mediaType, cdnOptions) => {
    const filmCdnUrl = cdnClient.instance.film(film);
    switch (mediaType) {
        case FilmHeroBannerMediaType.Advertisement:
        case FilmImageMediaType.Advertisement:
            return filmCdnUrl.advertisement(cdnOptions);
        case FilmHeroBannerMediaType.Backdrop:
        case FilmImageMediaType.Backdrop:
            return filmCdnUrl.backdrop(cdnOptions);
        case FilmImageMediaType.Poster:
            return filmCdnUrl.poster(cdnOptions);
        case FilmHeroBannerMediaType.Still:
        case FilmImageMediaType.Still:
            return filmCdnUrl.still(cdnOptions);
        case FilmImageMediaType.TitleTreatment:
            return filmCdnUrl.titleTreatment(cdnOptions);
        default:
            throw new Error(`Cannot get URL for unknown media type: '${mediaType}'.`);
    }
};
